import bean from "bean";

export default function eventify(obj) {
    ['on', 'off', 'fire'].forEach(f => {
        obj[f] = function() {
            bean[f].apply(bean, [ obj, ...arguments ]);
        };
    });
}